import React from "react";
import Background from "../../assets/images/hero/faq.jpg";
import faqQuestions from "../../assets/data/faqQuestions.json";
import Hero from "../Hero";
import FaqSection from "./FaqSection";
import AboutSection from "../Employer/Content/About/AboutSection";
import "../../css/Faq/Faq.css";

const aboutThisPage = [
  {
    content:
      "Below are a number of frequently asked questions that we received during our launch night. Feel free to browse this collection to see if your questions has already been answered.",
  },
];

const fullQuestionsList = [
  {
    title: "Eligibility",
    questions: faqQuestions[0].eligibility,
  },
  {
    title: "Work Placements",
    questions: faqQuestions[0].workPlacements,
  },
  {
    title: "General",
    questions: faqQuestions[0].general,
  },
  {
    title: "Microsoft Learn",
    questions: faqQuestions[0].msLearn,
  },
];

export default function Faq() {
  return (
    <div>
      <Hero title="FAQ" heroImage={Background} />
      <div className="about bg-light container-fluid pt-5 pb-5">
        <AboutSection title="FAQ Page" paragraphs={aboutThisPage} />
      </div>
      <div className="pb-5 bg-light">
        {fullQuestionsList.map((section, i) => {
          let toggleBackground = i % 2 === 0 ? "bg-white" : "bg-light";

          return (
            <div
              key={"FaqSection" + i}
              className={toggleBackground + " pt-4 pb-5"}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="pb-3 pt-1">
                      <h5 className="font-section-title">{section.title}</h5>
                    </div>
                    <FaqSection sectionList={section.questions} index={i + 1} />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
